export const feedbackDe = {
  open: 'Feedback geben',
  title: 'Feedback geben',
  description:
    'Melden Sie ein Problem, eine Frage oder einen Verbesserungsvorschlag, ohne die aktuelle Seite zu verlassen.',
  submit: 'Feedback absenden',
  submitting: 'Wird gesendet …',
  types: {
    BUG: 'Etwas funktioniert nicht',
    FEATURE_REQUEST: 'Funktionswunsch',
    IMPROVEMENT: 'Verbesserungsvorschlag',
    USABILITY: 'Bedienungsproblem',
    DATA_ISSUE: 'Daten wirken falsch oder unvollständig',
    PERFORMANCE: 'Seite ist langsam oder reagiert nicht',
    QUESTION: 'Frage zur Funktion',
    OTHER: 'Sonstiges',
  },
  urgencies: {
    LOW: 'Gering',
    NORMAL: 'Normal',
    HIGH: 'Hoch',
    BLOCKING: 'Ich kann nicht weiterarbeiten',
  },
  reproducibility: {
    ALWAYS: 'Immer',
    SOMETIMES: 'Manchmal',
    ONCE: 'Einmalig',
    NOT_TRIED: 'Noch nicht versucht',
  },
  statuses: {
    SUBMITTED: 'Eingegangen',
    TRIAGED: 'Bewertet',
    IN_PROGRESS: 'In Bearbeitung',
    RESOLVED: 'Gelöst',
    CLOSED: 'Geschlossen',
  },
  priorities: { LOW: 'Niedrig', MEDIUM: 'Mittel', HIGH: 'Hoch', CRITICAL: 'Kritisch' },
  fields: {
    type: 'Art der Meldung',
    urgency: 'Subjektive Dringlichkeit',
    title: 'Kurzer Titel',
    description: 'Ausführliche Beschreibung',
    noSecrets: 'Bitte keine Passwörter, Tokens, Zahlungsdaten oder vertraulichen Inhalte eingeben.',
    attemptedAction: 'Was wurde versucht?',
    actualResult: 'Was ist tatsächlich passiert?',
    expectedResult: 'Was wurde stattdessen erwartet?',
    reproducibility: 'Kann das Problem wiederholt werden?',
    reproductionSteps: 'Optionale Schritte zur Reproduktion',
    affectedFeature: 'Betroffene Funktion (optional)',
    wantsFollowUp: 'Rückfrage erwünscht',
    problematicFields: 'Problematische Felder',
    choose: 'Bitte auswählen',
  },
  bug: { title: 'Details zum Fehler' },
  screenshot: {
    title: 'Screenshot (optional)',
    hint: 'Prüfen und maskieren Sie vertrauliche Bereiche vor dem Absenden.',
    choose: 'Bild auswählen',
    remove: 'Entfernen',
    invalid: 'Das Bild konnte nicht gelesen werden.',
    maskArea: 'Screenshot zum Maskieren',
    maskInstructions: 'Ziehen Sie über vertrauliche Bereiche, um sie dauerhaft zu schwärzen.',
    resetMasks: 'Maskierungen zurücksetzen',
  },
  diagnostics: {
    includeExtended: 'Erweiterte Diagnosedaten beifügen',
    title: 'Diagnosedaten anzeigen',
    transparency:
      'Sie entscheiden, welche technischen Bereiche übertragen werden. Sitzungskontext wird serverseitig aus Ihrer Anmeldung ergänzt.',
    exclusions:
      'Nicht erfasst werden Eingaben, Suchbegriffe, Passwörter, Tokens, Nachrichten, Dateien, Zwischenablage, Audio, Kamera, Standort oder Mausbewegungen.',
    sections: {
      APPLICATION: 'Anwendung & Build',
      PAGE: 'Aktuelle Seite',
      BROWSER: 'Browser & Gerät',
      BREADCRUMBS: 'Letzte semantische Aktionen',
    },
  },
  discard: {
    title: 'Entwurf verwerfen?',
    description: 'Ihre noch nicht gesendeten Angaben gehen verloren.',
    continue: 'Weiter bearbeiten',
    confirm: 'Entwurf verwerfen',
  },
  success: {
    title: 'Feedback wurde gesendet',
    description: 'Bewahren Sie diese Referenz für Rückfragen auf.',
    toast: 'Feedback {{reference}} wurde gesendet.',
  },
  admin: {
    requested: 'Ja',
    nav: 'Feedback-Zentrale',
    title: 'Feedback-Zentrale',
    subtitle: 'Bewusst eingereichte Rückmeldungen mit bereinigtem Diagnosekontext verwalten.',
    loadError: 'Die Rückmeldungen konnten nicht geladen werden.',
    empty: 'Zu den gewählten Filtern liegen keine Rückmeldungen vor.',
    detailTitle: 'Feedback-Details',
    screenshotAlt: 'Maskierter Screenshot zu {{reference}}',
    triage: 'Technische Bewertung',
    unrated: 'Noch nicht bewertet',
    saved: 'Rückmeldung aktualisiert.',
    invalidErrorIds: 'Die Fehler-Referenzen sind ungültig.',
    linkedErrors: 'Verknüpfte Systemfehler',
    kpi: {
      open: 'Offene Meldungen',
      untriaged: 'Noch nicht bewertet',
      last24h: 'Letzte 24 Stunden',
    },
    columns: {
      reference: 'Referenz',
      createdAt: 'Zeitpunkt',
      type: 'Art',
      title: 'Titel',
      user: 'Benutzer',
      status: 'Status',
    },
    fields: {
      status: 'Bearbeitungsstatus',
      priority: 'Technische Priorität',
      errorIds: 'Error-Tracking-IDs (kommagetrennt)',
      notes: 'Interne Notizen',
    },
    filters: {
      search: 'Referenz, Titel oder Beschreibung',
      type: 'Art filtern',
      status: 'Status filtern',
      priority: 'Priorität filtern',
      all: 'Alle',
    },
    prompt: {
      title: 'Bereinigter Support-/Copilot-Prompt',
      hint: 'Freitext und Diagnosekontext werden vor dem Kopieren nochmals auf Geheimnisse und personenbezogene Muster bereinigt.',
      copy: 'Bereinigten Prompt kopieren',
      copied: 'Bereinigter Prompt wurde kopiert.',
    },
  },
} as const;
